import {type PS, MobileAlgoConditionType} from '@wix/document-services-types'
import type {MobileAlgoExtensionApi} from '@wix/document-manager-extensions/src/extensions/mobileAlgo/mobileAlgo'
import type {EnvironmentExtensionAPI} from '@wix/document-manager-extensions'
import {getReportableFromError, ReportableError} from '@wix/document-manager-utils'

export const runResponsiveMobileForAllPages = async (
    ps: PS,
    conditionType: MobileAlgoConditionType = MobileAlgoConditionType.RevisionSave
) => {
    const isEditor3 = (ps.extensionAPI as EnvironmentExtensionAPI).environment.isEditor3()
    if (isEditor3) {
        try {
            const {mobileAlgo} = ps.extensionAPI as MobileAlgoExtensionApi
            await mobileAlgo.runForAllPages({conditionType})
        } catch (e: any) {
            if (e.errorType !== 'GroupingModelNetworkError') {
                e.shouldRestoreRevision = true
            }

            ps.logger.captureError(
                e instanceof ReportableError
                    ? e
                    : getReportableFromError(e, {
                          errorType: 'ResponsifyAlgorithmError'
                      })
            )

            throw e
        }
    }
}

export const softLockSections = async (ps: PS) => {
    const isEditor3 = (ps.extensionAPI as EnvironmentExtensionAPI).environment.isEditor3()
    if (isEditor3) {
        const {mobileAlgo} = ps.extensionAPI as MobileAlgoExtensionApi
        mobileAlgo.locking.unlockSectionsForAllPages()
        await mobileAlgo.locking.softLockAllPages()
    }
}
